/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'util/PropTypes';
import { SVGIcon } from '@ba/ba-ui-carbon-toolkit';
import StringResources from 'nls/StringResources';
import close32 from '@ba/ba-graphics/dist/icons-js/close_32';

import './slideoutContent.scss';

const CLASS_NAME = 'explore-slideout-content';

class SlideoutContent extends Component {

	render() {
		const {
			className,
			children
		} = this.props;

		const header = this.renderHeader();
		const cNames = classNames(CLASS_NAME, className);
		const contentClassNames = this.props.contentClassName ?
			classNames( `${CLASS_NAME}__content`, `${CLASS_NAME}__${this.props.contentClassName}`) : `${CLASS_NAME}__content`;

		return (
			<div className={cNames} tabIndex={-1}>
				{header}
				<div className={contentClassNames}>
					{children}
				</div>
			</div>
		);
	}

	renderHeader() {
		const title = this.renderHeaderTitle();
		const subTitle = this.renderHeaderSubtitle();
		const closeButton = this.renderCloseButton();

		return (
			<div className={`${CLASS_NAME}__header`}>
				<div className={`${CLASS_NAME}__header__section`}>
					{title}
					{subTitle}
				</div>
				{closeButton}
			</div>
		);
	}

	renderHeaderTitle() {
		const { title } = this.props;
		return (
			<div className={`${CLASS_NAME}__header__section__title`}>
				{title}
			</div>
		);
	}

	renderHeaderSubtitle() {
		const { subTitle } = this.props;
		if (!subTitle) {
			return;
		}
		return (
			<div className={`${CLASS_NAME}__header__section__subTitle`}>
				{subTitle}
			</div>
		);
	}

	renderCloseButton() {
		if (this.props.onClose) {
			return (
				<div className={`${CLASS_NAME}__header__close-button`}>
					<button
						tabIndex='0'
						type='button'
						role='button'
						aria-label={StringResources.get('close')}
						title={StringResources.get('close')}
						onClick={() => this.props.onClose()}
					>
						<SVGIcon iconId={close32.id} />
					</button>
				</div>
			);
		}
	}
}

SlideoutContent.propTypes = {
	title: PropTypes.string.isRequired,
	subTitle: PropTypes.string,
	children: PropTypes.any,
	onClose: PropTypes.func,
	className: PropTypes.string,
	contentClassName: PropTypes.string
};
SlideoutContent.defaultProps = {
	showCloseButton: false,
	children: []
};

export default SlideoutContent;



// WEBPACK FOOTER //
// ./src/js/components/slideout/SlideoutContent.js